class collectionFilters extends HTMLElement {
    constructor() {
        super();
        this.params = new URLSearchParams(window.location.search)

        var $forms = this.querySelectorAll('select.form-field');
        if ($forms) {
            $forms.forEach($form => {
                this.setCurrentFilter($form);
                $form.addEventListener('change', this.updateData.bind(this));
            })
        }

        let $pageviews = this.querySelectorAll('li.utils-showby-item ');
        if ($pageviews) {
            $pageviews.forEach($view => {
                $view.addEventListener('click', this.updateNumberOfItemsPerPage.bind(this));
            })
        }
    }

    setCurrentFilter($form) {
        if (this.params.get($form.dataset.filter)) {
            let value = this.params.get($form.dataset.filter);
            let options = $form.querySelectorAll('option');
            options.forEach(option => {
                if (option.value === value) {
                    option.selected = true;
                }
            })
        }
    }

    updateNumberOfItemsPerPage(e) {
        const itemsPerPage = e.target.dataset.itemsQuantity;

        if (this.params.get( e.target.dataset.filter)) {
            this.params.delete( e.target.dataset.filter)
        }

        this.params.set(e.target.dataset.filter, itemsPerPage);

        window.location.search = this.params.toString();
    }

    updateData (e) {
        const formChange = e.target;

        if (this.params.get(formChange.dataset.filter)) {
            this.params.delete(formChange.dataset.filter)
        }

        if (formChange.value != 'all') {
            this.params.set(formChange.dataset.filter, formChange.value);
        }

        window.location.search = this.params.toString();
    }
}
customElements.define('collection-filters', collectionFilters);